import { render, staticRenderFns } from "./Hotline.vue?vue&type=template&id=dc167792"
import script from "./Hotline.vue?vue&type=script&lang=js"
export * from "./Hotline.vue?vue&type=script&lang=js"
import style0 from "./Hotline.vue?vue&type=style&index=0&id=dc167792&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports